import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({component:Component, ...rest}:any) => {
    return (
        <Route
            {...rest}
            render={props => 
                {
                    if(localStorage.getItem('access_token')) {
                        return <Component {...props} />
                    }
                    else{
                        return <Redirect to={
                            {
                                pathname:'/login',
                                state:{},
                            }
                        }/>
                    }
                }
            }
        />

    );
}

export default ProtectedRoute;